import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, model, output, untracked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule, SubscriptSizing } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'xp-password-field',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule
	],
	templateUrl: './xp-password-field.component.html',
	styleUrls: ['./xp-password-field.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpPasswordFieldComponent {
	label = input('');
	placeholder = input('');
	errorText = input('');
	showError = input(false);
	showToggle = input(true);
	showIcon = input('visibility_off');
	hideIcon = input('visibility');
	showLabel = input('Show password');
	hideLabel = input('Hide password');
	suffixIcon = input('');
	disabled = input(false);
	subscriptSizing = input<SubscriptSizing>('dynamic');
	inputTestId = input('');
	value = model('');
	visible = model(false);
	focused = output<void>();
	blurred = output<void>();

	/* The inner control carries no validator, so Material's default matcher would never paint the error. */
	errorStateMatcher: ErrorStateMatcher = { isErrorState: () => this.showError() };

	constructor() {
		/* Losing the button must hide the text again, or a field the screen locks would keep showing it. */
		effect(() => {
			if (!this.showToggle()) {
				untracked(() => this.visible.set(false));
			}
		});
	}

	toggleVisibility(): void {
		this.visible.update(shown => !shown);
	}
}
